import { useEffect, useState } from 'react'
import { PageHeader, StateBlock } from '../../shared/StateBlock'
import { ResponsiveTable } from '../../shared/ResponsiveTable'
import { ibApi, IbApiError } from '../api'

type ClientRow = {
  id: number
  email?: string
  phone?: string
  firstName?: string
  lastName?: string
  status?: string
  createdAt?: string
  accounts: Array<Record<string, unknown>>
}

export function IbClientsPage() {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [rows, setRows] = useState<ClientRow[]>([])

  useEffect(() => {
    void (async () => {
      setLoading(true)
      setError('')
      try {
        const data = await ibApi.clients()
        setRows(data.clients || [])
      } catch (err) {
        setError(err instanceof IbApiError ? err.message : 'Unable to load clients')
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  return (
    <div>
      <PageHeader eyebrow="IB portal" title="Your clients">
        <p className="cp-muted">
          View only — you cannot edit or credit client accounts from the IB portal.
        </p>
      </PageHeader>

      {error ? (
        <StateBlock tone="error" title="Error">
          {error}
        </StateBlock>
      ) : null}
      {loading ? (
        <p className="cp-muted ap-inline-status" aria-live="polite">
          Loading clients…
        </p>
      ) : null}

      <div className={`cp-panel${loading ? ' is-refreshing' : ''}`}>
        <ResponsiveTable
          rowKey={(c) => String(c.id)}
          columns={[
            {
              key: 'name',
              header: 'Client',
              render: (c) =>
                `${c.firstName || ''} ${c.lastName || ''}`.trim() || `Client #${c.id}`,
            },
            {
              key: 'email',
              header: 'Email / Mobile',
              render: (c) => (
                <span>
                  <strong>{c.email || '—'}</strong>
                  <br />
                  <span className="cp-muted">{c.phone || '—'}</span>
                </span>
              ),
            },
            { key: 'status', header: 'Status', render: (c) => c.status || '—' },
            {
              key: 'accounts',
              header: 'MT5 accounts',
              render: (c) =>
                (c.accounts || [])
                  .map((a) => `${a.mode || '?'} ${a.mt5Login || a.mt5_login || ''}`.trim())
                  .join(', ') || '—',
            },
            {
              key: 'created',
              header: 'Joined',
              render: (c) => (c.createdAt ? String(c.createdAt).slice(0, 10) : '—'),
            },
          ]}
          rows={rows}
          empty={
            loading
              ? 'Loading…'
              : 'No referred clients yet. Share your register link.'
          }
        />
      </div>
    </div>
  )
}
